import { Device } from '@capacitor/device';
import { render } from 'react-dom';
import {Provider as ReduxProvider} from 'react-redux';
import uuid from 'lodash-uuid';
import maxOf from './helpers/maxOf';
import upsertBy from './helpers/upsertBy';

_.mixin(uuid, {chain: true});
_.mixin({upsertBy, maxOf, isPresent: _.negate(_.isEmpty)});

import Rollbar from 'rollbar';
import rollbarConfig from 'config/rollbar';
window.Rollbar = new Rollbar(rollbarConfig);

import store, { repository, api } from 'store';
import { APIError } from './helpers/Rest';
import { loggedInSelector } from 'selectors/userSelector';

import App from 'app';
import StoreContext from 'contexts/StoreContext';
import 'styles/main.scss';

function getDeviceInfo() {
  return Device.getInfo().then((info) => {
    window.device = info;
    document.getElementById('root').classList.add(info.platform);
  });
}

function initRepository() {
  return repository.loadLocalStorage().then(async () => {
    repository.persist();
    if (loggedInSelector(store.getState())) {
      store.subscribe(_.throttle(repository.syncOfflineProjects, 30000, {leading: true}));
      try {
        await api.initializeAppData();
      } catch(e) {
        if (e instanceof APIError) {
          console.warn(e);
        } else {
          throw e;
        }
      }
    }
    store.subscribe(() => {
      const {user: {userInfo={}}} = store.getState();
      userInfo.id = userInfo.id || userInfo.email;
      window.Rollbar.configure({payload: {
        person: _.pick(userInfo, 'id', 'email', 'name', 'global_editor', 'is_admin')
      }});
    });
  });
}

const contexts = (
  <ReduxProvider store={store} >
    <StoreContext.Provider value={store}>
      <App />
    </StoreContext.Provider>
  </ReduxProvider>
)

Promise.all([getDeviceInfo(), initRepository()]).then(() => {
  render(contexts, document.getElementById('root'));
});
